import React, { useEffect } from 'react'
import { withGoogleMap, GoogleMap, Marker, InfoWindow } from 'react-google-maps'
import { getIconColor, svgMarker, pngMarker } from './utils'
import moment from 'moment'

const Map = withGoogleMap(
  ({
    organizations,
    selectedOrg,
    onMarkerClick,
    onInfoClose,
    center,
    zoom,
    showNonMembers,
  }) => {
    // Set initial map center and zoom using React state
    const [mapCenter, setMapCenter] = React.useState({ lat: 0, lng: 0 })
    const [mapZoom, setMapZoom] = React.useState(4)

    // Update map center and zoom when 'center' or 'zoom' prop changes
    useEffect(() => {
      setMapCenter(center)
      setMapZoom(zoom)
    }, [center, zoom])

    // Create a reference to the GoogleMap component
    const mapRef = React.createRef()

    return (
      <GoogleMap
        ref={mapRef}
        center={mapCenter}
        zoom={mapZoom}
        onZoomChanged={() => setMapZoom(mapRef.current.getZoom())}
      >
        {organizations
          .filter(({ isNspaMember }) => showNonMembers || isNspaMember)
          .map(
            ({
              id,
              latitude,
              longitude,
              type,
              name,
              category,
              website,
              isNspaMember,
              nspaMemberData,
            }) => (
              <Marker
                key={id}
                position={{
                  lat: +latitude,
                  lng: +longitude,
                }}
                onClick={() => onMarkerClick(id)}
                icon={{
                  url: pngMarker(isNspaMember ? type : 'Nonmember'),
                  scaledSize: new window.google.maps.Size(32, 32),
                }}
                zIndex={isNspaMember ? 1 : 0}
              >
                {selectedOrg === id && (
                  <InfoWindow onCloseClick={onInfoClose}>
                    <div>
                      <h5>{name}</h5>
                      {type && (
                        <div className="mb-1">
                          {isNspaMember && 'Member'} Type: {type}
                        </div>
                      )}
                      {category && (
                        <div className="mb-1">
                          Organization Category: {category}
                        </div>
                      )}
                      {nspaMemberData?.orgMemberSince && (
                        <div className="mb-1">
                          Member Since:{' '}
                          {moment(nspaMemberData.orgMemberSince).format(
                            'MMMM D, YYYY'
                          )}
                        </div>
                      )}
                      <div>
                        {website && (
                          <a href={website} target="_blank">
                            {website}
                          </a>
                        )}
                      </div>
                    </div>
                  </InfoWindow>
                )}
              </Marker>
            )
          )}
      </GoogleMap>
    )
  }
)

export default Map
